import { useCallback } from 'react';
import { openSnackbar } from '@/store/slices/snackbar';
import { useDispatch } from '@/store';
import { useTranslations } from 'next-intl';

const useSnackbar = () => {
  const dispatch = useDispatch();
  const t = useTranslations('Index');

  const showSuccessSnackbar = useCallback(
    (message: string) =>
      dispatch(
        openSnackbar({
          action: false,
          open: true,
          message: String(message),
          title: t('success'),
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'alert',
          alert: {
            color: 'success',
            variant: 'outlined',
          },
          transition: 'fade',
          actionButton: false,
          close: false,
        }),
      ),
    [],
  );

  const showWarningSnackbar = useCallback(
    (message: string) =>
      dispatch(
        openSnackbar({
          action: false,
          open: true,
          message: String(message),
          title: t('warning'),
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'alert',
          alert: {
            color: 'warning',
            variant: 'outlined',
          },
          transition: 'fade',
          actionButton: false,
          close: false,
        }),
      ),
    [],
  );

  const showErrorSnackbar = useCallback(
    (message: string) =>
      dispatch(
        openSnackbar({
          action: false,
          open: true,
          message: String(message),
          title: t('error'),
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'alert',
          alert: {
            color: 'error',
            variant: 'outlined',
          },
          transition: 'fade',
          actionButton: false,
          close: false,
        }),
      ),
    [],
  );

  return { showSuccessSnackbar, showWarningSnackbar, showErrorSnackbar };
};

export default useSnackbar;
